import makeStyles from '@mui/styles/makeStyles';
export const useStyles = makeStyles((theme) => ({
    showCounter: {
        padding: 0,
        display: 'flex',
        flexDirection: 'row',
        fontWeight: 700,
        fontSize: '1.25rem',
        textDecoration: 'none',
        textAlign: "center"
    },
    countdown: {
        lineHeight: '1.25rem',
        padding: theme.spacing(0, 1),
        display: 'flex',
        flexDirection: 'column',
        "&:first-of-type": {
            paddingLeft: 0
        },
        "&:last-of-type": {
            paddingRight: 0
        }
    },
    alignLeft: {
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    alignRight: {
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    alignCenter: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    alignColLeft: {
        alignItems: 'flex-start',
        "&:first-of-type": {
            paddingLeft: 0
        }
    },
    alignColRight: {
        alignItems: 'flex-end',
        "&:last-of-type": {
            paddingRight: 0
        }
    },
    alignColCenter: {
        alignItems: 'center',
    },
    countdownDanger: {
    //out of use for now but is meant to be a color warning if the timer is getting low
    //I'm leaving it in in case we decide we wanna connect it to a color defined in theme or have a static color that all companies use as an "alert" color
    // color: '#ff0000',
    },
    countdownText: {
        margin: 0,
    },
    timeDenomination: {
        textTransform: 'uppercase',
        fontSize: '0.75rem',
        lineHeight: '1rem',
    },
}));
